import { pb } from '@/libs/pocketbase'
import { tryCatch } from '@/utils/try-catch'
import type { CustomerEnrichmentPort } from '../domain/customer-enrichment'

const send = async (path: string, method: 'POST' | 'DELETE'): Promise<void> => {
	const result = await tryCatch(pb.send(path, { method, requestKey: null }))
	if (!result.isSuccess) throw new Error(result.error.message)
}

const pbCustomerEnrichment: CustomerEnrichmentPort = {
	request: (customerId: string): Promise<void> => send(`/api/customers/${customerId}/enrichment`, 'POST'),
	cancel: (customerId: string): Promise<void> => send(`/api/customers/${customerId}/enrichment/cancel`, 'POST'),
	clear: (customerId: string): Promise<void> => send(`/api/customers/${customerId}/enrichment`, 'DELETE'),
}

export { pbCustomerEnrichment }
